import {
  LIST_CLEAN_REQUEST,
  LIST_FETCH_REQUEST,
  LIST_FETCH_REQUEST_FAILURE,
  LIST_FETCH_REQUEST_SUCCESS,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
export const listsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case LIST_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case LIST_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case LIST_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
        pagination: {},
      });

    case LIST_CLEAN_REQUEST:
      return Object.assign({}, state, {
        loading: false,
        errors: {},
        payload: [],
        pagination: {},
      });

    default:
      return state;
  }
};

export default listsReducer;
